const initState = {};

const authReducer = (state = initState, action) => {
    switch(action.type){
      case 'LOGIN_ERROR':
        return {
          ...state,
          authError: 'Login failed'
        }
      case 'LOGIN_SUCCESS':
        return {
          ...state,
          user: action.user,
        }
      case 'LOGIN_VERIFY':
        return {
          ...state,
          openVerify: true,
        }      
      case 'LOGIN_DENY':
        return {
          ...state,
          isAdmin: false,
        }
      case 'SIGNOUT_SUCCESS':
        return state;
      default:
        return state;
    }
};

export default authReducer;